import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import {
  PricingSchemeHdrQueryCriteriaClass,
  PricingSchemeHdrCriteriaModelQuery
} from '../../../criteria/pricing-scheme-hdr-criteria.model';
import {
  BasicApiResponseModel,
  PagingResponseModel
} from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import {
  PricingSchemeContainerModel,
  PricingSchemeQueryCriteria
} from '../../../../../../models/aggregates/erp/pricing-scheme/pricing-scheme-container.model';

@Injectable({
  providedIn: 'root'
})
export class PricingSchemeService extends BaseApiTemplateService<PricingSchemeContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-schemes';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-schemes';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-schemes';
    this.httpClient = http;
  }

  public postByCriteriaPromise(queryCriteria: PricingSchemeQueryCriteria, visa: ApiVisa):
    Promise<PagingResponseModel<PricingSchemeContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + queryCriteria;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.post<PagingResponseModel<PricingSchemeContainerModel>>(
      this.apiUrl + '/query',
      queryCriteria,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: PricingSchemeHdrQueryCriteriaClass
  ): Promise<PagingResponseModel<PricingSchemeContainerModel>> {
    const buildDocCriteria = new PricingSchemeHdrCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<PricingSchemeContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getObservaleByCriteria(
    visa: ApiVisa, criteria?: PricingSchemeHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<PricingSchemeContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildDocCriteria = new PricingSchemeHdrCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<PricingSchemeContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }

  public postPricingSchemePromise(
    dtoObject: PricingSchemeContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<PricingSchemeContainerModel>> {
    return this.httpClient.post<BasicApiResponseModel<PricingSchemeContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public postPricingScheme(dtoObject: PricingSchemeContainerModel, visa: ApiVisa
  ): Observable<BasicApiResponseModel<PricingSchemeContainerModel>> {
    return this.httpClient.post<BasicApiResponseModel<PricingSchemeContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public editPricingSchemePromise(dtoObject: PricingSchemeContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<PricingSchemeContainerModel>> {
    return this.httpClient.put<BasicApiResponseModel<PricingSchemeContainerModel>>(
      this.apiUrl, dtoObject, this.getHttpHeader(visa))
      .toPromise();
  }
}